import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as ReactDOM from 'react-dom';
import { RemoveScroll } from 'react-remove-scroll';
import { useDispatch } from 'react-redux';
import Notifications from './notifications/Notifications';
import { DISABLE_ON_CLICK_OUTSIDE_CLASS } from '../hooks/useOnClickOutside';
import './_styles_/ModalDialog.css';
import { closeModalDialog, openModalDialog } from '../actions/modalDialogs';
import { createLogger } from '../utils/logging';
import useEffectOnLoad from '../hooks/useEffectOnLoad';

ModalDialog.propTypes = {
    onCancel: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

const MODAL_DIALOG_CLS_NAME = 'modal-dialog';

const logger = createLogger('ModalDialog');

function ModalDialog(props) {
    const {
        onCancel,
        children,
    } = props;
    useEffectOnLoad(() => {
        const allChildren = [].concat(children);
        allChildren.forEach((child) => child.props && logger.debug(`OPENING modal for: ${child.props?.className}`));
        return () => {
            allChildren.forEach((child) => child.props && logger.debug(`CLOSING modal for: ${child.props?.className}`));
        };
    });
    const dispatch = useDispatch();
    const contentRef = useRef(null);
    useEffect(() => {
        dispatch(openModalDialog());
        return () => {
            dispatch(closeModalDialog());
        };
    }, [dispatch]);
    useEffect(() => {
        const prevFocus = document.activeElement;
        contentRef.current.focus();
        return () => {
            prevFocus.focus();
        };
    }, [contentRef]);
    const cancelHandler = (event) => {
        event.stopPropagation();
        if (event.target.classList.contains(MODAL_DIALOG_CLS_NAME)) {
            logger.debug('Modal dialog closed by cancel handler.');
            onCancel();
        }
    };
    const keyUpHandler = (event) => {
        if (event.key === 'Escape') {
            event.stopPropagation();
            logger.debug('Modal dialog closed by kyeUp handler.');
            onCancel();
        }
    };
    return ReactDOM.createPortal(
        <RemoveScroll>
            <div className={`${MODAL_DIALOG_CLS_NAME} ${DISABLE_ON_CLICK_OUTSIDE_CLASS}`} onClick={cancelHandler} onKeyUp={keyUpHandler} role="presentation" tabIndex={-1} ref={contentRef}>
                <Notifications />
                {children}
            </div>
        </RemoveScroll>,
        document.body,
    );
}

export default ModalDialog;
